import { TextInput, Select, Button, addToast } from '@octano/global-ui';
import { TutorsResponse, SingleFormatedTutor } from '../types';
import { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { useSelectOptions } from '../hooks/useSelectOptions';
import { assignTutor } from '../../../api/studentTutorsRequests';
import { useTexts } from '../hooks/useTexts';

type Props = {
  allTutors: TutorsResponse['allTutors'];
  toggle: Function;
  modalData: SingleFormatedTutor | undefined;
  refresh: Function;
};

export const AssignTutorModal = ({
  allTutors,
  toggle,
  modalData,
  refresh,
}: Props) => {
  const texts = useTexts();
  const [selectedTutorAndStudyPlan, setSelectedTutorAndStudyPlan] = useState<{
    studyPlanEnrollmentId: number;
    label: string;
    value: number;
    email: string;
  } | null>();

  async function assignNewTutor() {
    if (!selectedTutorAndStudyPlan) {
      return;
    }
    toggle();
    const newTutor = await assignTutor(
      selectedTutorAndStudyPlan.studyPlanEnrollmentId,
      selectedTutorAndStudyPlan.value,
    );
    const succesfullyAssigned = !newTutor.error && newTutor.data.length === 1;
    addToast({
      icon: succesfullyAssigned ? 'check' : 'error',
      color: succesfullyAssigned ? 'success' : 'danger',
      text: succesfullyAssigned ? texts.toast.success : texts.toast.error,
    });
    succesfullyAssigned && refresh();
  }

  const formatedOptions = useSelectOptions(allTutors);
  if (!modalData) {
    return <></>;
  }
  return (
    <>
      <TextInput
        label={texts.modal.studyPlan}
        name="studyPlan"
        disabled
        value={modalData.name}
      />
      <Select
        label={texts.modal.nameAndId}
        name="nameAndId"
        isSearchable
        isClearable={false}
        options={formatedOptions}
        onChange={(e) => {
          setSelectedTutorAndStudyPlan({
            ...e,
            studyPlanEnrollmentId: modalData.studyPlanEnrollmentId,
          });
        }}
      />
      <TextInput
        label={texts.modal.email}
        name="email"
        value={selectedTutorAndStudyPlan?.email}
        disabled
      />
      <Row className="mt-5">
        <Col>
          <Button
            text={texts.modal.buttons.cancel}
            outlined
            fullwidth
            onClick={() => {
              setSelectedTutorAndStudyPlan(null);
              toggle();
            }}
          />
        </Col>
        <Col>
          <Button
            text={texts.modal.buttons.save}
            fullwidth
            disabled={!selectedTutorAndStudyPlan}
            onClick={() => assignNewTutor()}
          />
        </Col>
      </Row>
    </>
  );
};
